import React from "react";
import CloseImg from "../../../src/assets/images/close.png";

const SessionExpiredPopup = ({
  logout,
  setShowPopup,
  timeDifferenceInMinutes,
}) => {
  return (
    <div className="update-app-popup">
      <div className="popup-content" style={{ position: "relative" }}>
        <img
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
          }}
          src={CloseImg}
          alt=""
          onClick={() => setShowPopup(false)}
        />
        <h1 className="text-center">Session Alert</h1>
        <div className="text-center">
          <p>
            Your session is about to expire in {timeDifferenceInMinutes}{" "}
            {timeDifferenceInMinutes > 1 ? "minutes" : "minute"}. Please login
            again.
          </p>
        </div>
        <button
          onClick={logout}
          className="update-button btn-primary text-center wide"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredPopup;
